export default __webpack_public_path__ + "static/media/ASSIG.d3848b6e.gif";